// extracted by mini-css-extract-plugin
export default {"leftContent":"index_leftContent_EE56S"};